export const WedSideTemplateRoute = (() => {
  /** 官網版面-1 */
  const TemplatePagesArr1: any = [];

  /** 官網版面-2 */
  const TemplatePagesArr2: any = [];

  /** 官網版面-3 */
  const TemplatePagesArr3 = [
    { path: "", name: "Auth", pathName: "Auth", value: "Y", children: [] },
    { path: "", name: "結帳", pathName: "Checkout", value: "Y", children: [] },
    { path: "", name: "訂單完成", pathName: "CheckoutSecond", value: "Y", children: [] },
    { path: "", name: "中分類", pathName: "CommodityMid", value: "Y", children: [] },
    { path: "", name: "商品", pathName: "CommodityPage", value: "Y", children: [] },
    { path: "", name: "小分類", pathName: "CommoditySmall", value: "Y", children: [] },
    { path: "", name: "首頁", pathName: "Index", value: "Y", children: [] },
    { path: "", name: "登入", pathName: "Login", value: "Y", children: [] },
    {
      path: "",
      name: "會員資料",
      pathName: "MemberCenter",
      value: "Y",
      children: [
        { path: "", name: "基本資料", pathName: "MemberCenterBasicInfo", value: "Y", children: [] },
        { path: "", name: "付款資訊", pathName: "MemberCenterPayInfo", value: "Y", children: [] },
        { path: "", name: "收貨地址", pathName: "MemberCenterDeliveryAddress", value: "Y", children: [] },
        { path: "", name: "修改密碼", pathName: "MemberCenterChangePassword", value: "Y", children: [] },
        { path: "", name: "訂單查詢", pathName: "MemberCenterOrderSearch", value: "Y", children: [] },
        { path: "", name: "退訂/退貨查詢", pathName: "MemberCenterOrderReturnSearch", value: "Y", children: [] },
        { path: "", name: "折扣碼", pathName: "MemberCenterDiscountCode", value: "Y", children: [] },
        { path: "", name: "紅利", pathName: "MemberCenterDividend", value: "Y", children: [] },
        { path: "", name: "購物金", pathName: "MemberCenterShoppingPoints", value: "Y", children: [] },
        { path: "", name: "收藏清單", pathName: "MemberCenterFavoritesList", value: "Y", children: [] },
      ],
    },
    { path: "", name: "自訂頁面0", pathName: "CustomPage0", value: "Y", children: [] },
    { path: "", name: "自訂頁面1", pathName: "CustomPage1", value: "Y", children: [] },
    { path: "", name: "購物須知", pathName: "ShoppingGuide", value: "Y", children: [] },
    { path: "", name: "FAQ常見問題", pathName: "FAQPage", value: "Y", children: [] },
    { path: "", name: "隱私權條款", pathName: "TermPage", value: "Y", children: [] },
  ];

  /** 組件化嘗試版本 */
  const Template = [
    { path: "", name: "Auth", page: "Auth", value: "Y", children: [] },
    { path: "Checkout", name: "結帳", page: "Checkout", value: "Y", children: [] },
    { path: "CheckoutSecond", name: "訂單完成", page: "CheckoutSecond", value: "Y", children: [] },
    { path: "CommodityMid", name: "中分類", page: "CommodityMid", value: "Y", children: [] },
    { path: "CommodityPage", name: "商品", page: "CommodityPage", value: "Y", children: [] },
    { path: "CommoditySmall", name: "小分類", page: "CommoditySmall", value: "Y", children: [] },
    { path: "Index", name: "首頁", page: "Index", value: "Y", children: [] },
    { path: "Login", name: "登入", page: "Login", value: "Y", children: [] },
    {
      path: "MemberCenter",
      name: "會員資料",
      page: "MemberCenter",
      value: "Y",
      children: [
        { path: "", name: "基本資料", page: "MemberCenterBasicInfo", value: "Y", children: [] },
        { path: "", name: "付款資訊", page: "MemberCenterPayInfo", value: "Y", children: [] },
        { path: "", name: "收貨地址", page: "MemberCenterDeliveryAddress", value: "Y", children: [] },
        { path: "", name: "修改密碼", page: "MemberCenterChangePassword", value: "Y", children: [] },
        { path: "", name: "訂單查詢", page: "MemberCenterOrderSearch", value: "Y", children: [] },
        { path: "", name: "退訂/退貨查詢", page: "MemberCenterOrderReturnSearch", value: "Y", children: [] },
        { path: "", name: "折扣碼", page: "MemberCenterDiscountCode", value: "Y", children: [] },
        { path: "", name: "紅利", page: "MemberCenterDividend", value: "Y", children: [] },
        { path: "", name: "購物金", page: "MemberCenterShoppingPoints", value: "Y", children: [] },
        { path: "", name: "收藏清單", page: "MemberCenterFavoritesList", value: "Y", children: [] },
      ],
    },
    { path: "CustomPage0", name: "自訂頁面0", page: "CustomPage0", value: "Y", children: [] },
    { path: "CustomPage1", name: "自訂頁面1", page: "CustomPage1", value: "Y", children: [] },
    { path: "ShoppingGuide", name: "購物須知", page: "ShoppingGuide", value: "Y", children: [] },
    { path: "FAQPage", name: "FAQ常見問題", page: "FAQPage", value: "Y", children: [] },
    { path: "TermPage", name: "隱私權條款", page: "TermPage", value: "Y", children: [] },
  ];

  return {
    TemplatePagesArr1,
    TemplatePagesArr2,
    TemplatePagesArr3,
    Template,
  };
})();
